import VideoHelper from "video/VideoHelper";

export default class VideoPlayer {
    constructor($elem) {
        this.$element = $elem;
        this.url = this.$element.data('video-url');
        this.videoPath = this.$element.data('video-upload');
        this.$videoPlayer = this.$element.parent('.video-player__container').find('.js-video-container');

        this.videoPlayer = null;
    }

    show() {
        if (this.videoPlayer === null && !this.videoPath) {
            this.loadVideo();
        } else {
            this.$videoPlayer.append(eotwJSXFactory('video', {loop: true, controls: true, autoPlay: true, playsInline: true, muted: true, src: this.videoPath}))
        }
    }

    loadVideo() {
        let information = this.getVideoInformationFromUrl();
        console.log(information, this.url);

        if (information === null) return;
        this.videoPlayer = VideoHelper.process(information.provider, information.videoId, this.$videoPlayer, {});
        this.videoPlayer.on('loaded', () => {
            this.videoPlayer.play();
        });
    }

    getVideoInformationFromUrl() {
        let YoutubeTest = new RegExp(VideoHelper.PROVIDERS[VideoHelper.PROVIDER_YOUTUBE].url);
        if (YoutubeTest.test(this.url)) {
            return {
                "provider": VideoHelper.PROVIDER_YOUTUBE,
                "videoId": this.url.match(VideoHelper.PROVIDERS[VideoHelper.PROVIDER_YOUTUBE].url)[1]
            }
        }
        let VimeoTest = new RegExp(VideoHelper.PROVIDERS[VideoHelper.PROVIDER_VIMEO].url);
        if (VimeoTest.test(this.url)) {
            return {
                "provider": VideoHelper.PROVIDER_VIMEO,
                "videoId": this.url.match(VideoHelper.PROVIDERS[VideoHelper.PROVIDER_VIMEO].url)[1]
            }
        }

        return null;
    }

    destroy() {
        if (this.videoPlayer !== null) {
            this.videoPlayer.destroy();
        }
        return super.destroy();
    }
}
